export default __webpack_public_path__ + "static/media/gallery-3.c28c947e.jpg";